import { api } from '@/lib/trpc/react';
import { uploadBucket } from '@/utils/uploadFile';

interface ConvertFile {
  id: string;
  name: string;
  file: File;
  extension: string;
}

const useConvertFile = () => {
  const { mutateAsync: uploadConvert } =
    api.file.uploadConvertFile.useMutation();
  const { mutateAsync } = api.file.convertFile.useMutation();
  const { mutateAsync: convertSignedUrl } =
    api.file.convertSignedUrl.useMutation();

  const convertFile = async ({ id, name, file, extension }: ConvertFile) => {
    const { url, key } = await uploadConvert({
      name,
      chatbotId: id,
    });

    await uploadBucket({
      url,
      file,
    });

    const { url: signedUrl } = await convertSignedUrl(key);

    const convertedUrl = await mutateAsync({
      url: signedUrl,
      extension,
      key,
    });

    return convertedUrl;
  };
  return { convertFile };
};

export default useConvertFile;
